<template>
  <div id="guard_bg">
    <div v-if="!loading">
   <van-row class="car_shop">
         <van-col span="24" class="guard_wen">
            <img src="../assets/img/guard/guard_wen.png" alt="" class="guard_wen_img" @click="showGuardWenInfo">
            <img src="../assets/img/guard/guard_title.png" alt="" class="guard_title_img">
        </van-col>
        <van-col span="22" offset="1" class="guard_king_title">
           {{ $t('guard.guardian_king_desc') }}
        </van-col>
        <van-col span="24" class="guard_planet">
            <van-col span="24" class="guard_planet_king" v-if="guardian_king.head_image">
                <img :src="guardian_king.head_image" alt="" class="guard_planet_king_avatar">
                <img :src="guardian_king.guardian_level_frame" alt="" class="guard_planet_king_frame">
            </van-col>
            <van-col span="24" class="guard_planet_no_king" v-else>
                <img :src="host_user.head_image" alt="" class="guard_planet_host_avatar">
                <van-col span="4" offset="10" class="guard_planet_no_king_title">
                    <img src="../assets/img/guard/guard_address.png" alt="" class="guard_address">
                    {{ $t('guard.cygnus_61') }}
                </van-col>
                <img src="../assets/img/guard/guard_wang.png" alt="" class="guard_planet_no_king_img">
            </van-col>
        </van-col>
        <van-col span="24" class="guard_list_empty" v-if="guardian_list.length == 0">
            <van-col span="24" class="guard_list_empty_img">
                <img src="../assets/img/guard/guard_empty.png" alt="">
            </van-col>
            <van-col span="24" class="guard_list_empty_title">
                {{ $t('guard.no_guardians') }}
            </van-col>
            <van-col span="20" offset="2" class="guard_list_empty_btn" @click="showActivatePopup">
                {{ $t('guard.activate_guardian') }}
            </van-col>
        </van-col>
        <van-col span="24" class="guard_list" v-else>
            <van-col span="22" offset="1" class="guard_list_card" style="max-height: 400px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
                <van-col span="24" class="guard_list_card_item" v-for="item in guardian_list" :key="item.id">
                    <div class="guard_item_left">
                        <img :src="item.head_image" alt="" class="guard_item_avatar">
                        <div class="guard_item_info">
                            <div class="guard_item_top">
                                <span class="guard_item_name">{{ item.nick_name }}</span>
                                <span class="guard_item_level">
                                    <img :src="item.user_level_url" alt="" class="guard_badge_icon">
                                </span>
                                <span class="guard_item_level">
                                    <img :src="item.guardian_level_img" alt="" class="guard_badge_icon2">
                                </span>
                            </div>
                            <div class="guard_item_bottom">
                                <span>{{ $t('guard.spend_diamonds', {count: formatNumber(item.total_diamonds)}) }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="guard_item_right">
                        <div class="guard_remaining_label">{{ $t('guard.remaining_time') }}</div>
                        <div class="guard_remaining_days">{{ item.endtime }}</div>
                    </div>
                </van-col>
            </van-col>
             <van-col span="22" offset="1" class="guard_list_empty_btn2">
                <van-col span="22" offset="1" class="guard_list_empty_btn3" @click="showActivatePopup">
                    {{ $t('guard.activate_guardian') }}
                </van-col>
           </van-col>
        </van-col>
    </van-row>
    </div>

    <!-- 从右向左弹出的弹框 -->
    <van-popup v-model="showPopup" position="right"  class="guard-activate-popup" :close-on-click-overlay="true">
        <van-row>
            <van-col span="24" class="guard_popup_top">
                <van-col span="11" offset="1" class="guard_popup_top_left">
                    <van-icon name="arrow-left" size="20" @click="showPopup = false" />
                </van-col>
                <van-col span="11" class="guard_popup_top_right">
                      <img src="../assets/img/guard/guard_wen.png" alt="" @click="showGuardWenInfo">
                </van-col>
            </van-col>
            <van-col span="22" offset="1" class="guard_activate_hint">
                <div class="guard_activate_avatars">
                    <img :src="host_user.head_image" alt="" class="guard_activate_avatar_1">
                    <img :src="user.head_image" alt="" class="guard_activate_avatar_2">
                </div>
                <div class="guard_activate_text">
                    {{ $t('guard.activate_silver_guardian') }}
                </div>
            </van-col>
             <van-col span="22" offset="1" class="guard_activate_packages">
                <van-col span="24" class="guard_package_item" :class="['guard_package_item_' + item.level, {'guard_package_selected': selectedPackage === item.id}]" v-for="(item,j) in guardian_buy_rule" :key="j" @click="selectPackage(item)">
                    <div class="guard_package_hot" v-if="item.is_hot == 1">{{ $t('guard.hot') }}</div>
                    <div class="guard_package_hot" v-else-if="item.discount_name">{{ $t('guard.percent_off', {discount: item.discount_name}) }}</div>
                    <img src="../assets/img/guard/guard_select_type.png" alt="" class="guard_select_type" v-if="selectedPackage === item.id">
                    <div class="guard_package_duration">{{ item.name }}</div>
                    <div class="guard_package_price1">
                       <div class="guard_package_price">
                            <img src="../assets/img/coin.png" alt="" class="guard_package_diamond_icon">
                            <span class="guard_package_price_value">{{ formatNumber(item.coin) }}</span>
                        </div>
                        <div class="guard_package_price2" v-if="item.original_price > 0">
                            <img src="../assets/img/coin_h.png" alt="" class="guard_package_diamond_icon2">
                            <span class="guard_package_price_value2">{{ formatNumber(item.original_price) }}</span>
                        </div>
                    </div>
                    <div class="guard_package_type">{{ item.level_name }}</div>
                </van-col>

                
            </van-col>
            <van-col span="18" offset="3" class="guard_type_selector">
                <van-col span="8" class="guard_type_item">
                    <img src="../assets/img/guard/guard_type_xz1.png" alt="" class="guard_type_badge" :class="{'guard_type_badge_active': selectedTypePackage == 1}">
                    <div class="guard_type_label" :class="{'guard_type_label_active': selectedTypePackage == 1}">
                        <span v-if="guardian_level_title[1]">{{ guardian_level_title[1].name }}</span>
                        <div class="guard_type_arrow" v-if="selectedTypePackage == 1"></div>
                    </div>
                </van-col>
                <van-col span="8" class="guard_type_item">
                    <img src="../assets/img/guard/guard_type_xz2.png" alt="" class="guard_type_badge" :class="{'guard_type_badge_active': selectedTypePackage == 2}">
                    <div class="guard_type_label" :class="{'guard_type_label_active': selectedTypePackage == 2}">
                        <span v-if="guardian_level_title[2]">{{ guardian_level_title[2].name }}</span>
                        <div class="guard_type_arrow" v-if="selectedTypePackage == 2"></div>
                    </div>
                </van-col>
                <van-col span="8" class="guard_type_item">
                    <img src="../assets/img/guard/guard_type_xz3.png" alt="" class="guard_type_badge" :class="{'guard_type_badge_active': selectedTypePackage == 3}">
                    <div class="guard_type_label" :class="{'guard_type_label_active': selectedTypePackage == 3}">
                        <span v-if="guardian_level_title[3]">{{ guardian_level_title[3].name }}</span>
                        <div class="guard_type_arrow" v-if="selectedTypePackage == 3"></div>
                    </div>
                </van-col>
            </van-col>
            <van-col span="22" offset="1" class="guard_privileges_section">
                <div class="guard_privileges_header">
                    <span class="guard_privileges_wing">
                        <img src="../assets/img/guard/guard_privileges_wing_left.png" alt="">
                    </span>
                    <span class="guard_privileges_title">{{ $t('guard.guardian_privileges') }}</span>
                    <span class="guard_privileges_wing">
                        <img src="../assets/img/guard/guard_privileges_wing_right.png" alt="">
                    </span>
                </div>
                <div class="guard_privileges_cards">
                    <div class="guard_privilege_card">
                        <div class="guard_privilege_icon_wrap">
                            <img src="../assets/img/guard/guard_privilege_icon1.png" alt="" class="guard_privilege_icon">
                        </div>
                        <span class="guard_privilege_label">{{ $t('guard.exclusive_seats') }}</span>
                    </div>
                    <div class="guard_privilege_card">
                        <div class="guard_privilege_icon_wrap">
                            <img src="../assets/img/guard/guard_privilege_icon2.png" alt="" class="guard_privilege_icon">
                        </div>
                        <span class="guard_privilege_label">{{ $t('guard.guardian_badge') }}</span>
                    </div>
                    <div class="guard_privilege_card">
                        <div class="guard_privilege_icon_wrap">
                            <img src="../assets/img/guard/guard_privilege_icon3.png" alt="" class="guard_privilege_icon">
                        </div>
                        <span class="guard_privilege_label">{{ $t('guard.entry_effects') }}</span>
                    </div>
                </div>
            </van-col>
            <van-col span="22" offset="1" class="guard_activate_btn" @click="activateGuardian" v-if="is_guartian == 2">
                {{ $t('guard.activate_guardian') }}
            </van-col>
             <van-col span="22" offset="1" class="guard_activate_btn2" v-else>
                {{ $t('guard.activate_guardian') }}
            </van-col>
        </van-row>
    </van-popup>

    <!-- 守护说明弹框 -->
    <van-popup v-model="showGuardWenPopup" round class="guard-wen-info-popup" :close-on-click-overlay="true">
        <div v-html="article_content">
        </div>
    </van-popup>
  </div>
</template>

<script>

    import '@/assets/css/style.css'
    import axios from 'axios'
    import Toast from "vant/lib/toast"
    import {Dialog} from 'vant'
    export default {
        data() {
            return {
                loading: true,
                showPopup: false,
                showGuardWenPopup: false,
                showGuardianDescPopup: false,
                selectedPackage: 1,
                selectedTypePackage: 1,
                guardian_list: [],
                guardian_buy_rule:[],
                host_id: 0,
                is_guartian: 2,
                user: {
                    head_image: '',
                    nick_name: '',
                    user_id: ''
                },
                host_user: {
                    head_image: '',
                    nick_name: '',
                    user_id: ''
                },
                guardian_king: {
                    guardian_level: 0,
                    head_image: "",
                    nick_name: "",
                    uid: 0
                },
                article_content: '',
                guardian_level_title: []
            }
        },
        created () {
            this.host_id = this.$route.query.host_id;
            this.convert();
        },
        mounted() {
            this._outsideClickHandler = (e) => {
                if (this.showPopup || this.showGuardWenPopup || this.showGuardianDescPopup) return;
                const el = document.getElementById('guard_bg');
                if (el && !el.contains(e.target)) {
                    window.location.href = 'bogolive://exit';
                }
            };
            document.addEventListener('click', this._outsideClickHandler);
        },
        beforeDestroy() {
            if (this._outsideClickHandler) {
                document.removeEventListener('click', this._outsideClickHandler);
            }
        },
        methods: {
            convert() {
                this.loading = true;
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=guardians&act=index_v2",{
                    params : {
                        token: token,
                        host_id: this.host_id,
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 1) {
                       
                        this.guardian_buy_rule = res.data.data.guardian_buy_rule;
                        this.host_user = res.data.data.host_user;
                        this.user = res.data.data.user;
                        this.is_guartian = res.data.data.is_guartian;
                        this.guardian_king = res.data.data.guardian_king;
                        this.article_content = res.data.data.article_content;
                        this.guardian_level_title = res.data.data.guardian_level_title;
                        this.selectedPackage = this.guardian_buy_rule.length > 0 ? this.guardian_buy_rule[0].id : 0;
                        this.selectedTypePackage = this.guardian_buy_rule.length > 0 ? this.guardian_buy_rule[0].level : 0;
                        console.log(this.guardian_list);
                        this.guardian_list = [];
                        for(let i = 0; i< res.data.data.guardian_list.length; i ++) {
                            res.data.data.guardian_list[i]['user_level_url'] =  require('../assets/img/rank_'+res.data.data.guardian_list[i].user_level+'.png')
                            this.guardian_list.push(res.data.data.guardian_list[i])
                        }
                        console.log(this.host_user);
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                })
            },
        
            formatNumber(num) {
                if (num === undefined || num === null) return '0';
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            },
            showActivatePopup() {
                this.showPopup = true;
            },
            selectPackage(item) {
                this.selectedPackage = item.id;
                this.selectedTypePackage = item.level;
            },
            closePopup() {
                this.showPopup = false;
            },
            showGuardWenInfo() {
                this.showGuardWenPopup = true;
            },
            activateGuardian() {
                if (!this.selectedPackage) {
                    Toast(this.$t('guard.select_package'));
                    return;
                }
                 Dialog.confirm({
                    message: this.$t('guard.confirm_activate'),
                    confirmButtonText: this.$t('guard.confirm'),
                    cancelButtonText: this.$t('guard.cancel'),
                }).then(() => {
                    const token = this.$route.query.token;
                    axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=guardians&act=guardian_buy_v2", {
                        params: {
                            token: token,
                            host_id: this.host_id,
                            id: this.selectedPackage,
                        }
                    }).then(res => {
                        Toast(res.data.error);
                        if (res.data.status == 1) {
                            this.showPopup = false;
                            this.convert();
                        }
                    }).catch(() => {
                        Toast(this.$t('guard.network_error'));
                    });
                }).catch(() => {});
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/guard_list.vue